import React from 'react';
import { useTranslation } from 'react-i18next';
import noActivity from '../../../../../assets/images/chatbot_ai/no_activity_icon.svg';

const NoActivityPlaceholder = () => {
  const { t } = useTranslation('ChatbotIA');

  return (
    <div className="d-flex flex-column p-24 mb-15" style={{ backgroundColor: '#F6F8F9', borderRadius: 12 }}>
      <img src={noActivity} alt={t('memory.noActivity')} className="w-1/2 mx-auto" />
      <div className="align-self-center font fs-14" style={{ color: '#198FCC' }}>
        {t('memory.noActivity')}
      </div>
    </div>
  );
};

export default NoActivityPlaceholder;
